import { FullWidthLayout } from "@/layouts";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as Styled from "./legalPolicies";

export const CookiesScreen = () => {
  const rows = [
    {
      name: "_ga",
      provider: "Google",
      purpose:
        "Collects user information in order to provide analytics of the website",
      duration: "Two years",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "_ga_M8DQYEJ7Z9",
      provider: "Google",
      purpose:
        "Collects user information in order to provide analytics of the website",
      duration: "Two years",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "_gat_UA-235355050-1",
      provider: "Google",
      purpose: "Provides technical monitoring",
      duration: "One Minute",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "_gcl_au",
      provider: "Google",
      purpose: "Stores and tracks conversions",
      duration: "Two months",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "_gid",
      provider: "Google",
      purpose: "Stores and counts pageviews",
      duration: "One Day",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "NID",
      provider: "Google",
      purpose:
        "Provides ad delivery or retargeting, stores user preferences",
      duration: "Six Months",
      type: "Third-Party",
      consent: "NO",
    },
    {
      name: "DSID",
      provider: "Google",
      purpose: "Stores users preferences",
      duration: "Two weeks",
      type: "Third-Party",
      consent: "NO",
    },
  ];
  return (
    <FullWidthLayout
      id="free-trial"
      bgColor="var(--background-light)"
      borderColor="var(--on-primary-dark)"
    >
      <Styled.LegalContainer>
        <Styled.BoxContent>
          <h1 className="headline-large weight-medium">
            Cookies Policy
          </h1>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">
            Who we are
          </h2>
          <p className="body-medium">
            CELLECT ENERGY S.L (hereinafter &quot;CELLECT&quot; or
            “we”) is the owner of the website cellectenergy.com
            (hereinafter the &quot;Web Site&quot;) and uses cookies
            that collect information related to the connection,
            browsers and devices used by Internet users who access and
            use the Web site (hereinafter the &quot;User/s&quot;).
            CELLECT uses this information to manage and improve the
            proper functioning of the Web Site.
          </p>
          <p className="body-medium">
            This policy describes what information these cookies
            collect, how they are used and for what purpose. It also
            indicates how the User can restrict or block the automatic
            downloading of cookies; however, this may reduce or even
            hinder certain elements of the functionality of the Web
            Site. Likewise, the User can choose the category of
            cookies he/she wishes to activate in the cookie banner
            that appears the first time that he/she accesses the Web
            Site
          </p>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">
            Definition of cookies
          </h2>
          <p className="body-medium">
            Cookies are small text files that are placed on the
            User&apos;s computer, smartphone or other device when
            accessing the Internet. This is done to improve the
            User&apos;s experience and for other purposes, such as
            recognizing Users when accessing the Site, ensuring the
            security of your account and delivering targeted
            advertising.
          </p>
          <p className="body-medium">
            Cookies are small text files that are placed on the
            User&apos;s computer, smartphone or other device when
            accessing the Internet. This is done to improve the
            User&apos;s experience and for other purposes, such as
            recognizing Users when accessing the Site, ensuring the
            security of your account and delivering targeted
            advertising.
          </p>
          <p className="body-medium">
            In summary, CELLECT uses the cookies listed in Annex I to
            this Policy to track how the Web Site is used in order to
            optimize its operation.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">
            What cookies we use
          </h2>
          <p className="body-medium">
            We will process your personal data according to our
            Privacy Policy.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">
            Protection of Personal Data
          </h2>
          <p className="body-medium">
            We will process your personal data according to our
            Privacy Policy.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Cookies</h2>
          <p className="body-medium">
            The Web Site uses own-cookies or first-party cookies
            (cookies sent to your device by CELLECT through the web
            domain) and third-party cookies (which are sent to your
            device by domains that are not managed by CELLECT but by
            another entity that processes the data collected through
            cookies). The cookies used can be divided into the
            following categories:
          </p>
          <p className="body-medium">
            Technical cookies (necessary): cookies necessary for
            navigation and for the proper functioning of the Web Site.
            Their use allows basic functions, such as access, secure
            navigation. The legal basis that allows the collection of
            data through these cookies is the execution of the
            contract (the Terms and Conditions) applicable to all
            Users and the legitimate interest of CELLECT in the
            management of the Web Site. No information collected
            through these cookies is shared with third parties. Please
            refer to the cookie table below for details of these
            cookies.
          </p>
          <p className="body-medium">
            Analytical Cookies: allow monitoring and analyzing the
            behavior of Users. The information collected through this
            type of cookies is used in measuring the activity of the
            Web Site and for profiling User&apos;s browsing, in order
            to improve the Web Site. The legal basis that allows the
            collection of this data through these cookies is the
            consent of the User. See the table of cookies below for
            details of these cookies.
          </p>
          <p className="body-medium">
            You can find the detailed list of the cookies we use, the
            type, purpose and duration of each one of them in the
            table of cookies below.
          </p>
        </Styled.BoxContent>

        {/* Table of cookies */}
        <div style={{ width: "100%", overflow: "auto" }}>
          <TableContainer sx={{ maxWidth: "100%" }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Provider</TableCell>
                  <TableCell>Purpose</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Consent</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((cookie) => (
                  <TableRow
                    key={cookie.name}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {cookie.name}
                    </TableCell>
                    <TableCell>{cookie.provider}</TableCell>
                    <TableCell>{cookie.purpose}</TableCell>
                    <TableCell>{cookie.duration}</TableCell>
                    <TableCell>{cookie.type}</TableCell>
                    <TableCell>{cookie.consent}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">
            Disable cookies
          </h2>
          <p className="body-medium">
            The User may restrict or limit the placement of cookies by
            adjusting the browser settings. However, if you select
            this setting, you may not be able to access certain parts
            of the Web Site or cause a poor display of its contents,
            which will result in less efficient navigation, and you
            may not be able to take advantage of some of the services
            available. Therefore, it is recommended that you do not
            disable them. If you wish to disable cookies, go to the
            Browser Preferences menu or Browser settings and look for
            the Privacy section. As an example, you can follow the
            instructions below:
          </p>
          <a
            className="body-medium weight-medium"
            href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09#:~:text=Abre%20Microsoft%20Edge%20y%20selecciona,sitio%20y%20luego%20Borrar%20ahora"
          >
            Microsoft Edge
          </a>
          <a
            className="body-medium weight-medium"
            href="https://support.google.com/chrome/answer/95647"
          >
            Google Chrome
          </a>
          <a
            className="body-medium weight-medium"
            href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
          >
            Safari
          </a>
          <a
            className="body-medium weight-medium"
            href="http://support.mozilla.org/kb/delete-cookies-remove-info-websites-stored"
          >
            Mozilla Firefox
          </a>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  );
};
